const calculateNameInitial = (name) => {
    if (name === null || name === undefined) {
        name = "Jane Doe";
    }
    
    const nameSlugs = name.split(" ");
    const initialOfFirstName = nameSlugs[0][0];
    const initialOfLastName =
        nameSlugs.length > 1 ? nameSlugs[nameSlugs?.length - 1][0] : "";
    const initial = (initialOfFirstName + initialOfLastName).toUpperCase();

    return initial;
};

export default calculateNameInitial;
